import ApiContext from 'api/ApiContext';
import { PollDetailsListGroup } from 'api/api.types';
import { useContext, useMemo } from 'react';
import { FormattedList } from './getFormattedCandidates';

export const useGetFormattedListGroups = (
  lists: PollDetailsListGroup[],
  isFinal?: boolean,
  finishedCircles?: number,
): FormattedList[] => {
  const { language } = useContext(ApiContext);

  const formattedLists = useMemo(() => {
    return lists?.map((li) => {
      return {
        title: li.title[language],
        shortTitle: li.short_title[language],
        seatsClaimed: li.results?.seat_claim || 0,
        listId: li.id,
        color: li.color,
        listNumber: 'list_number' in li ? li.list_number : undefined, // only available for IssueList
        votesRelative: li.results?.voters_count_percentage,
        votesAbsolute: parseFloat(li.results?.voters_count.toFixed(2)),
        partyId: 'party_id' in li ? li.party_id : undefined, // only available for IssueList. Required to map a list to a party
        // some group-lists (e.g. FFF) only attend in some circles. If only those circles are counted where FFF did not attend, it has no results object yet
        noCirclesCounted: !('results' in li),
      };
    });
  }, [!lists, isFinal, finishedCircles]);

  return formattedLists;
};
